/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, AreaChart } from 'recharts';
import L from "../Lang";

export default class InvoiceSalesChart extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.orderID !== prevProps.orderID)
            this.load();
    }

    load = () => {
        qreq.get('/api/invoice/chart/sales', j => {
            if (j.list)
                this.setState({ data: j.list });
        });
    }

    render() {
        return <ResponsiveContainer width="100%" height={300}>
            <AreaChart
                width={500}
                height={300}
                data={this.state.data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <defs>
                    <linearGradient id="InvoiceSalesChartColorDx" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#828aca" stopOpacity={0.8} />
                        <stop offset="95%" stopColor="#828aca" stopOpacity={0} />
                    </linearGradient>
                    <linearGradient id="InvoiceSalesChartColorEdx" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                        <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={a => a ? <div className="bg-light text-dark border border-dark p-3"><div>{a.payload && a.payload.length > 0 && a.payload[0].payload ? a.payload[0].payload.name : null}</div><div>{a.payload && a.payload.length > 0 ? Globals.formatCurrency(a.payload[0].value) : null}</div></div> : null} />
                <Legend payload={[{ value: <L>Total $ Invoiced</L>, type: 'line', id: 'ID01', color: '#7cae35' }]} />
                <Area type="monotone" dataKey="dv" stroke="#7cae35" fillOpacity={1} fill="url(#InvoiceSalesChartColorDx)" />
            </AreaChart>
        </ResponsiveContainer>;
    }
}